import React, { Component } from "react";
import { searchComposer } from "ReactReducers/Search/search-composer";
import SearchPagination from "ReactComponents/Search/search-pagination";

class ContentSearchResults extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMounted: false
        };

        this.scrollToTop = this.scrollToTop.bind(this);
    }

    componentDidMount() {
        this.setState({
            isMounted: true
        });
    }

    scrollToTop() {
        if (!this.state.isMounted) {
            return;
        }

        const el = document.querySelector(".searchpage-results__content");

        if (!el) {
            return;
        }

        window.scrollTo({ top: el.offsetTop - 200, behavior: "smooth" });
    }

    render() {
        const resultList = this.props.contentSearchResults;

        return (
            <div className="searchpage-results__content">
                {resultList.length > 0 ? (
                    <div>
                        <ul className="searchpage-results__content-list">
                            {resultList.map((result, index) => {
                                return (
                                    <li key={index} className="searchpage-results__content-list__item">
                                        <a href={result.Url}>
                                            <span dangerouslySetInnerHTML={{ __html: result.Title }} />
                                        </a>
                                        <p dangerouslySetInnerHTML={{ __html: result.Snippet }} />
                                    </li>
                                );
                            })}
                        </ul>
                        <SearchPagination
                            hasPrevious={this.props.contentSearchHasPrevious}
                            onClickPrevious={this.props.contentSearchPrevious}
                            hasNext={this.props.contentSearchHasNext}
                            onClickNext={this.props.contentSearchNext}
                            pageIndex={this.props.contentSearchPage + 1}
                            totalCount={this.props.totalCount}
                            pageSize={this.props.pageSize}
                            previousButtonLabel={this.props.previousButtonLabel}
                            nextButtonLabel={this.props.nextButtonLabel}
                            paginationIndicator={this.props.paginationIndicator}
                            scrollToTop={this.scrollToTop}
                        />
                    </div>
                ) : (
                    <div className="searchpage-results__empty-text">{this.props.emptyContentText}</div>
                )}
            </div>
        );
    }
}

export default searchComposer(ContentSearchResults);
